import i18n from '@/locales'
export default {
  namespaced: true,
  state: {
    items: []
  },
  actions: {
    addError ({ commit, dispatch }, message) {
      const item = {
        type: 'error',
        message: message,
        timeout: 8
      }
      dispatch('_addItem', item)
    },
    addErrorByViolations ({ dispatch }, violations) {
      violations.forEach(e => {
        dispatch('addError', `${e.message}`)
      })
    },
    // manages error messages snackbars  by checking either violations or details
    // errorMessage must be i18n error key
    addErrorHandler (
      { dispatch },
      { error, errorMessage = 'snackbar_generic_error' }
    ) {
      if (error.response) {
        if (
          error.response.data.violations &&
          error.response.data.violations.length > 0
        ) {
          dispatch('addErrorByViolations', error.response.data.violations)
        } else {
          dispatch(
            'addError',
            i18n.t(errorMessage) +
            (error.response.data.detail
              ? '<br>' + error.response.data.detail
              : '')
          )
        }
      } else if (error.message) {
        if (error.message === 'Network Error') {
          dispatch('addNetworkError')
        } else {
          dispatch('addError', error.message)
        }
      } else {
        if (!('cancel' in error)) {
          return
        }

        dispatch('addError', i18n.t(errorMessage))
      }
    },
    addSuccess ({ commit, dispatch }, message) {
      const item = {
        type: 'success',
        message: message,
        timeout: 2
      }
      dispatch('_addItem', item)
    },
    addSuccessOnboarding ({ commit, dispatch }, message) {
      const item = {
        type: 'success_onboarding',
        message: message,
        timeout: 5
      }
      dispatch('_addItem', item)
    },
    addNetworkError ({ dispatch }) {
      const item = {
        type: 'network_error',
        message: i18n.t('network_error_message'),
        timeout: 10
      }
      dispatch('_addItem', item)
    },
    addInfo ({ commit, dispatch }, message) {
      const item = {
        type: 'info',
        message: message,
        timeout: 2
      }
      dispatch('_addItem', item)
    },
    addInfoAction ({ commit, dispatch }, { message, action }) {
      const item = {
        type: 'info',
        message: message,
        timeout: 25,
        action: action
      }
      dispatch('_addItem', item)
    },
    addWarningAction ({ commit, dispatch }, { message, action }) {
      const item = {
        type: 'warning',
        message: message,
        timeout: 25,
        action: action
      }
      dispatch('_addItem', item)
    },
    addWarning ({ commit, dispatch }, message) {
      const item = {
        type: 'warning',
        message: message,
        timeout: 8
      }
      dispatch('_addItem', item)
    },
    _addItem ({ commit, dispatch, getters }, item) {
      const itemsHasNetworkErrorAlready =
        getters.items.findIndex(el => el.type === 'network_error') > -1

      if (itemsHasNetworkErrorAlready) return

      if (getters.itemsCount >= 3) {
        setTimeout(() => dispatch('_addItem', item), 1000)
        return
      }
      item.id = parseInt(Math.random() * 10000000000, 10)
      commit('addItem', item)
      if (item.timeout) {
        setTimeout(() => {
          dispatch('removeItem', item.id)
        }, item.timeout * 1000)
      }
    },
    removeItem ({ commit, state }, id) {
      const key = state.items.findIndex(e => e.id === id)
      commit('removeItem', key)
    },
    clearSnackbars ({ commit }) {
      commit('clearSnackabrs')
    }
  },
  mutations: {
    addItem (state, payload) {
      state.items.push(payload)
    },
    removeItem (state, key) {
      state.items.splice(key, 1)
    },
    clearSnackbars: state => {
      state.items = []
    }
  },
  getters: {
    items: state => state.items,
    itemsCount: state => state.items.length
  }
}
